import React from 'react'

export const childrenBirthYear = (props) => {
    const {
        input,
        label,
        meta: {touched, error},
        disabled,
	    placeholder,
	    onClick,
        required = false
    } = props

    return (
		<div className={(touched && error ? 'is-invalid' : '')}>

			<div className="input-group">
				<input id={input.name}
				       placeholder={placeholder}
				       type="text"
				       {...input}
				       disabled={disabled === true}
				       className={'form-control ' + (touched && error ? 'is-invalid' : '')}/>
				<div className="input-group-append">
					<button type="button" className="input-group-text btn btn-secondary btn-removechild" onClick={onClick}>x</button>
				</div>
			</div>

			{touched && error && <p className="text-danger"><span>{error}</span></p>}
		</div>
    )
}

